import React, { useCallback, useEffect, useRef, useState } from "react";
import { FocusSDK, isFocusEnv } from "@/utils";
import "./index.less";
import IconFont from "@/components/icon";
import { getSuperviseInfo, readSupervise } from "@/api/supervise";
import Dayjs from "dayjs";
import Bus from "@/utils/bus";
import {
  IcreateSupervise,
  SuperviseType,
  Receiver,
  ReadFlag,
  IcommentResp,
  EsendType,
  Owner
} from "@/types/supervise";
import i18n from "@/i18n";
import { useAppId } from "@/components/Supervise/envirment";
import { getWxDate } from "@/utils/date";
import ImService from "@/server/ImService";
import { userEscapeString } from "@/utils/chat/index";
import colors from "@/components/styles/colors";
import { connect } from "dva";
import { analysisLog } from "@/utils/logAnalytics";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
export default function SuperviseNoticeCard({
  params,
  closeCurWindow,
  winTimer
}: {
  params: any;
  closeCurWindow: Function;
  winTimer: number;
}) {
  const { mid, sessionId, superviseId, deepLink = "" } = params;
  const [detailData, setDetailData] = useState<IcreateSupervise | null>(null);
  const [owner, setOwner] = useState<Owner | null>(null);
  const appId = useAppId();
  const [isDelete, setIsDeleted] = useState(false);
  const [isForceLogout, setIsForceLogout] = useState(false);
  const wtimer = useRef<any>(null);
  // const [isFlag, setFlag] = useState(true);
  let isFlag = true;

  useEffect(() => {
    getSuperviseInfo({
      superviseId: superviseId!
    }).then((res) => {
      const data: IcreateSupervise = res[0];
      const err: string | null = res[1];
      if (!data) {
        if (err) {
          setIsDeleted(true);
          return;
        }
      }
      const { owner } = data;
      setDetailData(data);
      setOwner(owner);
    });
  }, [setDetailData, setOwner, superviseId]);

  const closeNoticeCard = useCallback(() => {
    if (isFocusEnv()) {
      Bus.emit("supervise/update");
      closeCurWindow?.();
    }
  }, [closeCurWindow]);

  const viewDetail = useCallback(() => {
    if (!isFocusEnv()) {
      return;
    }
    analysisLog("Xtbg_Urgency_ForcedPopup", "Details");
    if (!isForceLogout) {
      DeeplinkEvent.open(deepLink);
      FocusSDK.sendIpcMessage("showMainwindow");
    }
    // tj: 已被踢出后直接关闭
    closeNoticeCard();
  }, [isForceLogout, closeNoticeCard, deepLink]);

  useEffect(() => {
    if (isDelete) {
      if (isFocusEnv()) {
        // 发送消息到桌面端
        closeNoticeCard();
      }
    }
  }, [isDelete, closeNoticeCard]);
  const readHandle = useCallback(() => {
    if (!isFlag) {
      return;
    }
    analysisLog("Xtbg_Urgency_ForcedPopup", "Close");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    isFlag = false;
    // setFlag(false);
    readSupervise({
      superviseId: superviseId!,
      readFlag: ReadFlag.read
    })
      .then(async (res) => {
        if (ImService.getInstance()) {
          const _mid = Number(mid || "");
          const _sessionId = sessionId || "";
          if (!isNaN(_mid) && _sessionId) {
            await ImService.getInstance().readMessageById(_mid, _sessionId);
          }
        }
        if (isFocusEnv()) {
          // 发送消息到桌面端
          closeNoticeCard();
        }
      })
      .finally(() => {
        setTimeout(() => {
          isFlag = true;
        }, 1000);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closeNoticeCard, superviseId, mid, sessionId]);

  // tj: 强制退出 (解决强制退出后点击提醒页面卡死)
  const forceQuitListener = useCallback(() => {
    setIsForceLogout(true);
  }, []);

  useEffect(() => {
    Bus.on("chat:force_quit", forceQuitListener);
    return () => {
      Bus.off("chat:force_quit", forceQuitListener);
    };
  }, [forceQuitListener]);

  // 定时关闭
  useEffect(() => {
    if (winTimer) {
      wtimer.current = setTimeout(() => {
        analysisLog("Xtbg_Urgency_ForcedPopup", "AutoClose");
        closeNoticeCard();
      }, winTimer * 60 * 1000);
    }
    return () => {
      wtimer.current && clearTimeout(wtimer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="supervise-notice-card">
      {/* <div className="snc-spliter" /> */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          flex: 1
        }}
      >
        <div style={{ flex: 1, padding: "8px 16px 0" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between"
            }}
          >
            <IconFont
              className="scn-primary"
              style={{ fontSize: 20 }}
              type="iconic_app_more_remind"
            />
            <p
              style={{
                flex: 1,
                fontSize: 14,
                color: `${colors.black2}`,
                marginLeft: 10
              }}
            >
              {owner?.realName}
              {i18n.t(`supervise:desupervise${appId}`)}
            </p>
            <IconFont className="scn-close" type="iconty_close" onClick={readHandle} />
          </div>

          <p
            className="snc-content"
            style={{ whiteSpace: "pre-wrap" }}
            dangerouslySetInnerHTML={{
              __html: userEscapeString((detailData as any)?.content)
            }}
          />
          <p className="snc-content">{getWxDate(detailData?.time || 0)}</p>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
          <p className="snc-btn" onClick={viewDetail}>
            {i18n.t("supervise:viewDetail")}
          </p>
          <p className="snc-btn-primary" onClick={readHandle}>
            {i18n.t("supervise:close")}
          </p>
        </div>
      </div>
    </div>
  );
}
